import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/brand/logo.png";
import bg from "../assets/brand/bg6.png";
import closs from "../assets/brand/closs.png";
import API_BASE_URL from "../config";  // ADD THIS LINE

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // REMOVE THIS LINE - no longer needed
  // const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    // Check if the user is already logged in
    if (localStorage.getItem("token")) {
      navigate("/");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    console.log("Attempting to login with", { email, password });

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {  // CHANGE THIS LINE
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      console.log("Response data:", data);

      if (response.ok) {
        // Save the token and user details in localStorage
        localStorage.setItem("token", data.token);
        localStorage.setItem("userName", data.user.name);
        localStorage.setItem("position", data.user.position);
        localStorage.setItem("userId", data.user.id);

        // Redirect to the home page after successful login
        navigate("/");
      } else {
        console.log("Login failed:", data);
        setError(data.message || "Invalid credentials");
      }
    } catch (error) {
      console.error("An error occurred:", error);
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <div className="login">
      <div className="xl:grid grid-cols-2 gap-2">
        <div className="hidden xl:flex flex-col min-h-screen">
          <a href="" className="-intro-x flex items-center pt-5">
            <img alt="Logo" className="w-44" src={logo} />
            <span className="text-white font-900 text-center text-xl ml-1 mt-16 uppercase">
              ITORERO METHODISTE<br></br> LIBRE MU RWANDA
            </span>
          </a>
          <div className="-intro-x mt-5 mr-[150px] text-xl text-white text-opacity-70 dark:text-slate-200">
            {/* Keep watch over yourselves and all the flock of which the Holy Spirit has made you overseers. Be shepherds of the church of God, which he bought with his own blood */}
          </div>
          <div className="my-auto">
            <img alt="Background" className="-intro-x w-[70%] mt-[-70px]" src={bg} />
          </div>
        </div>
        <div className="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
          <div className="my-auto mx-auto xl:ml-2 bg-white dark:bg-darkmode-600 xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto">
            <h2 className="font-bold text-[#164E63] text-2xl xl:text-3xl text-center">
              EMLR PARUWASI KICUKIRO <br></br><span className="text-xl tracking-widest font-montserrat">Management System</span>
            </h2>

            {error && <div className="text-red-500 text-center mt-4">{error}</div>}

            <div className="intro-x mt-8">
              <input
                type="text"
                className="intro-x text-xl login__input form-control py-2 px-2 block"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="password"
                className="intro-x text-xl login__input form-control py-2 px-2 block mt-4"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="intro-x mt-5 xl:mt-8 text-center xl:text-left">
              <button
                className="btn btn-primary py-2 px-2 w-full xl:w-32 xl:mr-3 align-top"
                onClick={handleLogin}
              >
                <b className="text-xl">Login</b>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;